var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4954 15C3.34877 14.9982 -0.00183973 11.6413 7.57872e-07 7.49126C0.00184125 3.34581 3.3589 -0.00275886 7.51104 1.70564e-06C11.6549 0.00276227 15.0037 3.36237 15 7.51426C14.9972 11.6505 11.6374 15.0009 7.49448 15H7.4954ZM1.20828 7.50322C1.2092 10.9631 4.0362 13.79 7.49724 13.7909C10.9647 13.7918 13.7926 10.9631 13.7917 7.49586C13.7899 4.03503 10.9638 1.20821 7.50276 1.20821C4.03528 1.20821 1.20736 4.03595 1.20828 7.50322Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14298 5.70581C7.14324 5.70517 7.14337 5.7045 7.14337 5.70381C7.14337 4.97775 7.14178 4.25168 7.14337 3.52561C7.14496 3.02286 7.5418 2.70936 7.90046 2.92824C8.10961 3.05536 8.19311 3.27424 8.19311 3.55047C8.19232 4.84367 8.19391 6.13783 8.18993 7.43103C8.18993 7.55624 8.22095 7.62984 8.30604 7.70153C9.02813 8.3142 9.74704 8.9326 10.466 9.55101C10.7196 9.76893 10.7864 10.1321 10.6306 10.4256C10.4667 10.7333 10.1351 10.8079 9.87587 10.5881C9.30488 10.1016 8.73548 9.61218 8.16607 9.12376C7.90841 8.90297 7.65234 8.67836 7.39229 8.46044C7.22051 8.31611 7.14258 8.12113 7.14258 7.87262C7.14337 7.15133 7.14258 6.42909 7.14258 5.7078C7.14258 5.70711 7.14271 5.70644 7.14298 5.70581Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockicon);
export default __webpack_public_path__ + "static/media/clockicon.06e660e3337377ac1c938ca235e6c4d1.svg";
export { ForwardRef as ReactComponent };